



import navSec from './sections/nav-sec';
import testInfoSec from './sections/test-info-sec';
import formValidation from './sections/form-validation';
import scrollToHash from './sections/scroll-to-hash';
import accordionOpenScrollToTop from './sections/accordion-open-scroll-to-top';



jQuery(function () {
    navSec()
    testInfoSec()
    formValidation()
    scrollToHash()
    accordionOpenScrollToTop()
})



